import axios from "../../config/axiosConfig";
import {
  ORDER_BALANCE_STOCK_REPORT_REQUEST,
  ORDER_BALANCE_STOCK_REPORT_SUCCESS,
  ORDER_BALANCE_STOCK_REPORT_FAILURE,
  ORDER_BALANCE_STOCK_FILTER_REPORT_REQUEST,
  ORDER_BALANCE_STOCK_FILTER_REPORT_SUCCESS,
  ORDER_BALANCE_STOCK_FILTER_REPORT_FAILURE,
  ORDER_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS,
  SET_OUTSTANDING_BY_ACCOUNTS,
} from "../types/order-balance-stock-report-types";

export const getOrderBalanceBillBaseReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_BALANCE_STOCK_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        filterType: params?.filterType,
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/stock-report/getOrderBalanceBillBaseReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.post('/stock-report/getOrderBalanceBillBaseReport', requestParams, { params: defaultParams }).then((response) => {
        console.log('>>>API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: ORDER_BALANCE_STOCK_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching order balance(bill base) Report:", error);
        dispatch({ type: ORDER_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching order balance(bill base) Report:", error);
      dispatch({ type: ORDER_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getOrderBalanceStockFilterDetail = (params = {}) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: ORDER_BALANCE_STOCK_FILTER_REPORT_REQUEST });

            const { auth } = getState();
            const defaultParams = {
                finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.user?.Customer_Id,
            };
            const requestParams = { ...defaultParams, ...params };

            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/stock-report/getOrderBalanceBillBaseOptions?${queryString}`;

            console.log('<<Complete API Request URL: ', fullUrl);

            return axios.get(fullUrl).then((response) => {
                console.log('API Response Data: ', response);
                if (response.data) {
                dispatch({ type: ORDER_BALANCE_STOCK_FILTER_REPORT_SUCCESS, payload: response.data });
                }
            }).catch((error) => {
                console.error("Error fetching order balance(bill base) Report:", error);
                dispatch({ type: ORDER_BALANCE_STOCK_FILTER_REPORT_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error("Error fetching order balance(bill base) Report:", error);
            dispatch({ type: ORDER_BALANCE_STOCK_FILTER_REPORT_FAILURE, error: error.message });
        }
    };
};

export const clearOrderBalanceBillBaseStockReportReport = () => {
  return async (dispatch) => {
        dispatch({ type: ORDER_BALANCE_STOCK_REPORT_SUCCESS, payload: {} });
  }
}

export const closeOrderWithTransaction = (orderId, transactionId) => {
  return async (dispatch, getState) => {
    try {
      const queryString = new URLSearchParams({ orderId, transactionId }).toString();
      const fullUrl = `/sales-order/closeOrder?${queryString}`;
      // Make API call
      return axios.put(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          return response;
        }
      }).catch((error) => {
        console.error("Error closing order:", error);
        throw error;
      });
    } catch (error) {
      console.error("Error closing order:", error);
      throw error;
    }
  };
};

export const closeOrderSchedule = (transactionId) => {
  return async (dispatch, getState) => {
    try {
      const queryString = new URLSearchParams({ transactionId }).toString();
      const fullUrl = `/sales-order/close-order-delivery-schedule?${queryString}`;
      // Make API call
      return axios.put(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          return response;
        }
      }).catch((error) => {
        console.error("Error closing order:", error);
        throw error;
      });
    } catch (error) {
      console.error("Error closing order:", error);
      throw error;
    }
  };
};

export const getOutstandingByAccounts = (accountIds) => {
  return async (dispatch, getState) => {
    try {
      // Make API call
      return axios.post('/outstanding-report/sales-outstanding-by-account-ids', { accountIds })
      .then((response) => {
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SET_OUTSTANDING_BY_ACCOUNTS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching order balance(bill base) Report:", error);
        dispatch({ type: ORDER_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching order balance(bill base) Report:", error);
      dispatch({ type: ORDER_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getOrderBalanceChallanBaseReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_BALANCE_STOCK_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        filterType: params?.filterType,
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      const requestParams = { ...defaultParams, ...defaultParams2 };
      console.log('Request Param Datas >>', requestParams);

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/stock-report/getOrderBalanceChallanBaseReport?${queryString}`;

      console.log('>Complete API Request URL: ', fullUrl);

      return axios.post('/stock-report/getOrderBalanceChallanBaseReport', requestParams, { params: defaultParams }).then((response) => {
        console.log('>>>API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: ORDER_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching order balance(challan base) Report:", error);
        dispatch({ type: ORDER_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching order balance(challan base) Report:", error);
      dispatch({ type: ORDER_BALANCE_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};
export const clearOrderBalanceChallanBaseStockReportReport = () => {
  return async (dispatch) => {
        dispatch({ type: ORDER_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS, payload: {} });
  }
}

export const updateOrderCheckStatusUserWise = (id, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      return axios.put("/stock-report/update-order-check-status-user-wise", { saleOrderTransactionId: id, data },
        { params: { userId: auth.user?.id, finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth.user?.Customer_Id } }
      ).then((response) => {
        return response;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};